import { useEffect } from "react";

/**
 * Lightweight SEO hook — set <title> and key meta tags per-route.
 * Restores original values on unmount so deep links keep canonical SEO.
 */
export default function useSEO({
  title,
  description,
  noindex = false,
  canonical,
} = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const prevRobots = document
      .querySelector('meta[name="robots"]')
      ?.getAttribute("content");
    const prevDesc = document
      .querySelector('meta[name="description"]')
      ?.getAttribute("content");
    const prevCanonical = document
      .querySelector('link[rel="canonical"]')
      ?.getAttribute("href");

    if (title) document.title = title;
    if (description) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
    if (noindex) {
      let tag = document.querySelector('meta[name="robots"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "robots");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", "noindex, nofollow");
    }
    if (canonical) {
      let tag = document.querySelector('link[rel="canonical"]');
      if (!tag) {
        tag = document.createElement("link");
        tag.setAttribute("rel", "canonical");
        document.head.appendChild(tag);
      }
      tag.setAttribute("href", canonical);
    }

    return () => {
      document.title = prevTitle;
      if (prevDesc) {
        document
          .querySelector('meta[name="description"]')
          ?.setAttribute("content", prevDesc);
      }
      if (prevRobots !== undefined) {
        document
          .querySelector('meta[name="robots"]')
          ?.setAttribute("content", prevRobots);
      }
      if (prevCanonical) {
        document
          .querySelector('link[rel="canonical"]')
          ?.setAttribute("href", prevCanonical);
      }
    };
  }, [title, description, noindex, canonical]);
}
